import { MenuItem, TextField } from '@mui/material';
import PropTypes from 'prop-types';

import cancelOrderReasons from 'common/constants/cancelOrderReasons';

import { NON_ROUTABLE_CANCEL_REASONS } from '../constants/nonRoutableRequests';

/**
 * The required "Reason for cancelling" dropdown shared by both Non-Routable cancels (the request
 * Cancel and the fax order Cancel). The chosen code is sent to the partner as the ORDER_CANCELED
 * webhook `reason`.
 */
const NonRoutableCancelReasonField = ({ id, value, onChange, disabled }) => (
  <TextField
    select
    required
    fullWidth
    variant='standard'
    sx={{ mt: 2 }}
    id={id}
    label='Reason for cancelling'
    value={value}
    onChange={(event) => onChange(event.target.value)}
    disabled={disabled}
  >
    {NON_ROUTABLE_CANCEL_REASONS.map((key) => (
      <MenuItem key={key} value={key}>
        {cancelOrderReasons[key]}
      </MenuItem>
    ))}
  </TextField>
);

NonRoutableCancelReasonField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

NonRoutableCancelReasonField.defaultProps = {
  disabled: false,
};

export default NonRoutableCancelReasonField;
